(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-series-selector"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.pss-wrapper').forEach(function(wrapper) {
    wrapper.querySelectorAll('[data-pss-group]').forEach(function(group) {
      var tabs = group.querySelectorAll('[data-tab-id]');
      var variantsData = JSON.parse(group.getAttribute('data-variants-json') || '[]');
      if (!variantsData.length) return;

      function updateGroup(variantId) {
        var v = null;
        for (var i = 0; i < variantsData.length; i++) {
          if (String(variantsData[i].id) === String(variantId)) { v = variantsData[i]; break; }
        }
        if (!v) return;

        var img = group.querySelector('[data-product-image]');
        if (img) { img.src = v.image; img.alt = v.title; }

        var title = group.querySelector('[data-product-title]');
        if (title) title.textContent = v.title;

        // rich_text 用 innerHTML 渲染加粗等格式
        var desc = group.querySelector('[data-product-description]');
        if (desc) desc.innerHTML = v.desc_html;

        var price = group.querySelector('[data-badge-price]');
        if (price) price.textContent = v.price;

        var link = group.querySelector('[data-price-link]');
        if (link) link.href = v.url;
      }

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          tabs.forEach(function(t) { t.classList.remove('active'); });
          tab.classList.add('active');
          updateGroup(tab.getAttribute('data-tab-id'));
        });
        tab.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            tab.click();
          }
        });
      });

      var active = group.querySelector('[data-tab-id].active');
      if (active) updateGroup(active.getAttribute('data-tab-id'));
    });
  });
})();

// 灯箱初始化（全局只创建一次）
if (!document.querySelector('.pss-lightbox')) {
  var lb = document.createElement('div');
  lb.className = 'pss-lightbox';
  lb.innerHTML = '<span class="pss-lightbox__close">&times;</span><img class="pss-lightbox__img" src="" alt="" />';
  document.body.appendChild(lb);

  var lbImg = lb.querySelector('.pss-lightbox__img');

  lb.addEventListener('click', function(e) {
    lb.classList.remove('open');
  });
  lb.querySelector('.pss-lightbox__close').addEventListener('click', function(e) {
    e.stopPropagation();
    lb.classList.remove('open');
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') lb.classList.remove('open');
  });

  // 点击图片触发灯箱
  document.addEventListener('click', function(e) {
    var img = e.target.closest('[data-product-image]');
    if (!img) return;
    // 把 width=200 换成 width=1600 获取大图
    var bigSrc = img.src.replace(/(_\d+x\d*\.|_\d*x\d+\.)/, '.').replace(/width=\d+/, 'width=1600');
    lbImg.src = bigSrc;
    lbImg.alt = img.alt;
    lb.classList.add('open');
  });
}


  } catch(e) { console.error(e); }
})();
})();
